import React from "react";
import AutoTyping from "react-auto-typing";
import operationImage from "../../../assets/operation-management.jpg";
import technicianImage from "../../../assets/technician-empowerment.jpg";
import customerImage from "../../../assets/customer-engagement.png";
import contractImage from "../../../assets/contract-management.png";

const FeaturesOnServices = () => {
  return (
    <div className="aristi-feature-section-wrapper">
      <div className="section-title">
        <h1 className="title">Key Features of Aristi</h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Features"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={operationImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Robust Multi-Factor Authentication</h1>
            <ul className="main-list">
              <li>
                <h6>Biometric Fingerprint Verification</h6>
                <ul className="inner-list">
                  <li>
                    Strengthen your security with state-of-the-art biometric
                    authentication, ensuring that only authorized users gain
                    access to critical systems and sensitive information.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Authenticator App Integration</h6>
                <ul className="inner-list">
                  <li>
                    Leverage an easy-to-use authenticator app that generates
                    time-based codes, providing an additional layer of security
                    while maintaining user convenience.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Seamless Compatibility</h1>
            <ul className="main-list">
              <li>
                <h6>Banking Platform Integration</h6>
                <ul className="inner-list">
                  <li>
                    Aristi seamlessly integrates with banking systems like
                    Finacle and other enterprise platforms, enhancing security
                    without disrupting existing workflows.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Versatile Application Across Industries</h6>
                <ul className="inner-list">
                  <li>
                    Whether in finance, healthcare, or e-commerce, Aristi adapts
                    to various sectors, ensuring secure access to sensitive data
                    and applications.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={technicianImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={customerImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Effortless Compliance and Reporting</h1>
            <ul className="main-list">
              <li>
                <h6>Automated Log Generation</h6>
                <ul className="inner-list">
                  <li>
                    Generate detailed logs and reports automatically,
                    simplifying the auditing process and ensuring compliance
                    with industry regulations.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Real-Time Monitoring</h6>
                <ul className="inner-list">
                  <li>
                    Stay informed with real-time access to authentication
                    activities, allowing for proactive security management and
                    quick response to potential threats.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Integration and Scalability</h1>
            <ul className="main-list">
              <li>
                <h6>Seamless Software Integration</h6>
                <ul className="inner-list">
                  <li>
                    Easily integrate Aristi with your existing systems to create
                    a unified security environment that enhances operational
                    efficiency.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Scalable Security Solutions</h6>
                <ul className="inner-list">
                  <li>
                    As your organization grows, Aristi scales effortlessly,
                    ensuring robust security measures keep pace with your
                    evolving needs.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={contractImage} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesOnServices;
